




















































































































































































































































































































import Vue from "vue";
import eventBus from "@/services/eventBus";
import { Grid } from "@progress/kendo-vue-grid";
import LookupComboBox from "@/modules/transactions/components/LookupComboBox.vue";
import ValidationError from "@/modules/downPayment/components/ValidationError.vue";
import IconButton from "@/components/IconButton.vue";
import BookingTemplateItemDimensionEdit from "../components/BookingTemplateItemDimensionEdit.vue";
import auth from "@/services/auth";
import api from "../services/api";
import { Year } from "../models/YearModell";
import {
  BookingTemplate,
  BookingTemplateItem,
  emptyBookingTemplate,
  emptyBookingTemplateItem,
} from "../models/BookingTemplate";
import { t } from "@/plugins/i18n";

// K2D "Könyvelési sablonok" (w_resp_hmboktranstemp) full-page szerkesztő.
// Fej: TransactionHeadEdit minta; tételek: TransactionItemEdit minta (sorra kattintva szerkeszthető,
// soron belüli sárga törlés-megerősítő). A tétel szorzó (total) 0..1 arány, NEM összeg.
// A főkönyvi szám lista a kiválasztott KÖNYVELÉSI ÉVHEZ kötött (K2D il_Year, alapból az aktív év):
// mmbokaccno, status 3/4, nem gyűjtő — ezt a GetInvoiceMirrorsByYear végpont már így szűri.

interface YearOption {
  value: number;
  label: string;
}

interface Data {
  saving: boolean;
  editor: BookingTemplate | null;
  accounts: any[];
  dimensions: any[];
  bookTypes: any[];
  years: Year[];
  selectedYear: number;
  selectedDebitItem: BookingTemplateItem | null;
  selectedCreditItem: BookingTemplateItem | null;
  sides: string[];
  uidCounter: number;
  itemColumns: any[];
}

interface Methods {
  loadYears(): Promise<void>;
  loadBookTypes(): Promise<void>;
  loadYearData(): Promise<void>;
  loadEditor(): Promise<void>;
  dimCodesFor(type: number): any[];
  onDimCodeChange(item: BookingTemplateItem, dimNo: number, selected: any): void;
  onBookTypeChange(item: BookingTemplateItem): void;
  selectedItemFor(side: string): BookingTemplateItem | null;
  setSelectedItem(side: string, item: BookingTemplateItem | null): void;
  sideItems(side: string): BookingTemplateItem[];
  sideSum(side: string): number;
  sideSumRounded(side: string): number;
  addItem(side: string): void;
  removeItem(item: BookingTemplateItem): void;
  onRowClick(e: any): void;
  isEditing(item: BookingTemplateItem): boolean;
  rowRender(h: any, trElement: any, defaultSlots: any, props: any): any;
  askDelete(item: BookingTemplateItem): void;
  confirmRemove(item: BookingTemplateItem): void;
  cancelRemove(item: BookingTemplateItem): void;
  onAccountChange(item: BookingTemplateItem, selected: any): void;
  hasDimensions(item: BookingTemplateItem): boolean;
  dimensionSummary(item: BookingTemplateItem): string;
  save(): Promise<void>;
  cancel(): Promise<void>;
}

interface Computed {
  isEdit: boolean;
  accountOptions: any[];
  yearOptions: YearOption[];
  insDateOnly: string;
  alive: boolean;
  error: string;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  name: "BookingTemplateEditor",

  components: {
    Grid,
    LookupComboBox,
    ValidationError,
    IconButton,
    BookingTemplateItemDimensionEdit,
  },

  data(): Data {
    return {
      saving: false,
      editor: null,
      accounts: [],
      dimensions: [],
      bookTypes: [],
      years: [],
      selectedYear: 0,
      selectedDebitItem: null,
      selectedCreditItem: null,
      sides: ["+", "-"],
      uidCounter: 0,
      itemColumns: [
        { cell: "actionsCell", title: "", width: "80px", filterable: false, sortable: false },
        { cell: "accnoCell", title: t("FokonyviSzam"), width: "220px" },
        { cell: "totalCell", title: t("GeneralLedger_Szorzo"), width: "100px" },
        // K2D dimcode1-3 (1–3. dimenzió) — LookupComboBox-szal szerkeszthető (mmbokdimcode, type 2/3/4).
        { cell: "dim1Cell", title: t("GeneralLedger_DimI"), width: "170px" },
        { cell: "dim2Cell", title: t("GeneralLedger_DimII"), width: "170px" },
        { cell: "dim3Cell", title: t("GeneralLedger_DimIII"), width: "170px" },
        { cell: "bookTypeCell", title: t("Naplo"), width: "170px" },
        { cell: "currencyCell", title: t("Penznem"), width: "100px" },
        // K2D inv_no: összerendelési csoportszám — az azonos számú tartozik/követel tételek egy csoport
        // (üres/1 = nincs összerendelve). Betöltéskor a "Tételek összerendelése" kapcsoló veszi át.
        { cell: "invNoCell", title: t("Osszerendeles"), width: "130px" },
        { cell: "noteCell", title: t("Megjegyzes"), width: "200px" },
        { filterable: false, width: 0 }
      ],
    };
  },

  computed: {
    isEdit(): boolean {
      return Number(this.$route.params.id) > 1;
    },

    accountOptions(): any[] {
      // A GetInvoiceMirrorsByYear már status 3/4 + nem gyűjtő szűréssel ad vissza (K2D picker szabály).
      return this.accounts;
    },

    yearOptions(): YearOption[] {
      return this.years.map((y) => ({
        value: Number(y.year),
        label: y.name && y.name.trim() ? y.name : String(y.year),
      }));
    },

    // Csak megjelenítés (év-hónap-nap); az insDate a backendről teljes ISO datetime-ként jön.
    insDateOnly(): string {
      return this.editor && this.editor.insDate ? this.editor.insDate.substring(0, 10) : "";
    },

    // Élő kapcsoló: a deleted flag fordítottja (mentéskor a backend a Deleted-et perzisztálja).
    alive: {
      get(): boolean {
        return !!this.editor && !this.editor.deleted;
      },
      set(val: boolean) {
        if (this.editor) this.editor.deleted = !val;
      },
    },

    // TF szerkesztő minta: computed error string vezérli a mentés tiltását + <validation-error>-t.
    error(): string {
      const e = this.editor;
      if (!e) return "";
      if (!e.name || !e.name.trim()) return t("GeneralLedger_ASablonNevenekMegadasaKotelezo");
      for (const item of e.items) {
        if (!item.accno || item.accno <= 1) return t("GeneralLedger_MindenTetelhezFokonyviSzamotKellValasztani");
        if (!item.total || item.total <= 0) return t("GeneralLedger_MindenTetelSzorzojaNagyobbKellLegyen");
        // K2D MSG_DIMCODE_YET: egy tétel adott dimenziójának felosztásán belül a dimenziókód nem ismétlődhet.
        const seenDimCodes = new Set<string>();
        for (const d of item.dimensions) {
          if (d.dimCode <= 1) continue;
          const key = `${d.dimCodeType}:${d.dimCode}`;
          if (seenDimCodes.has(key))
            return t("GeneralLedger_AZDimenzioFelosztasabanUgyanazA", [d.dimCodeType - 1]);
          seenDimCodes.add(key);
        }
      }
      // K2D grid-accepttext szabály: SUM(total) > 1 tiltott (MSG_1); a < 1 megengedett.
      if (this.sideSumRounded("+") > 1) return t("GeneralLedger_ATartozikOldalSzorzoinakOsszegeNem");
      if (this.sideSumRounded("-") > 1) return t("GeneralLedger_AKovetelOldalSzorzoinakOsszegeNem");
      return "";
    },
  },

  async beforeMount() {
    eventBus.$emit("busy-message", true);
    try {
      await this.loadYears();
      await this.loadBookTypes();
      await this.loadYearData();
      await this.loadEditor();
    } finally {
      eventBus.$emit("busy-message", false);
    }
  },

  methods: {
    async loadYears() {
      this.years = await api.GetGeneralLedgerYears();
      // K2D il_Year alapértéke a globális aktív év — itt: a mai naptári évhez tartozó, különben a legfrissebb.
      const current = new Date().getFullYear();
      const match = this.years.find((y) => Number(y.year) === current);
      const sorted = [...this.years].sort((a, b) => Number(b.year) - Number(a.year));
      this.selectedYear = match ? Number(match.year) : sorted.length ? Number(sorted[0].year) : 0;
    },

    async loadBookTypes() {
      this.bookTypes = await api.GetBookTypes();
    },

    // Évhez kötött adatok: aktív főkönyvi számok (K2D il_Year) + dimenzió-kódok a dim1-3 választókhoz.
    async loadYearData() {
      if (!this.selectedYear) {
        this.accounts = [];
        this.dimensions = [];
        return;
      }
      const [accounts, dimensions] = await Promise.all([
        api.GetInvoiceMirrorsByYear(this.selectedYear),
        api.GetDimensionCodesByYear(this.selectedYear),
      ]);
      this.accounts = accounts;
      this.dimensions = dimensions;
    },

    // Oldalanként külön kijelölt tétel (TransactionStore positive/negativeSelectedItem minta):
    // "+" = tartozik, "-" = követel.
    selectedItemFor(side: string): BookingTemplateItem | null {
      return side === "+" ? this.selectedDebitItem : this.selectedCreditItem;
    },

    setSelectedItem(side: string, item: BookingTemplateItem | null) {
      if (side === "+") this.selectedDebitItem = item;
      else this.selectedCreditItem = item;
    },

    sideItems(side: string): BookingTemplateItem[] {
      return this.editor ? this.editor.items.filter((x) => x.accSign === side) : [];
    },

    sideSum(side: string): number {
      return this.sideItems(side).reduce((s, x) => s + (Number(x.total) || 0), 0);
    },

    // A szorzók lebegőpontos összeadása miatt (0.333+0.333+0.334 = 1.0000000000000002) az 1-es
    // határt 3 tizedesre kerekítve nézzük, hogy a pontosan 1.000 összeg ne akadjon el.
    sideSumRounded(side: string): number {
      return Math.round(this.sideSum(side) * 1000) / 1000;
    },

    addItem(side: string) {
      if (!this.editor) return;
      // K2D UX-default: az új sor szorzója az 1-ből még hiányzó maradék.
      const remainder = Math.max(0, Math.round((1 - this.sideSum(side)) * 1000) / 1000);
      const item = emptyBookingTemplateItem(side, remainder);
      item.uid = ++this.uidCounter;
      this.editor.items.push(item);
      // Az új sort azonnal szerkeszthetővé tesszük (kijelöljük a saját oldalán).
      this.setSelectedItem(side, item);
    },

    removeItem(item: BookingTemplateItem) {
      if (!this.editor) return;
      this.editor.items = this.editor.items.filter((x) => x !== item);
      // Törlés után az oldal első megmaradt tétele lesz kijelölve (TransactionEditor minta).
      if (this.selectedItemFor(item.accSign) === item) {
        this.setSelectedItem(item.accSign, this.sideItems(item.accSign)[0] || null);
      }
    },

    // Sorra kattintva a sor szerkeszthetővé válik a saját oldalán (TransactionItemEdit minta).
    onRowClick(e: any) {
      this.setSelectedItem(e.dataItem.accSign, e.dataItem);
    },

    isEditing(item: BookingTemplateItem): boolean {
      const selected = this.selectedItemFor(item.accSign);
      return !!selected && item.uid === selected.uid;
    },

    // A kijelölt (szerkesztett) sor kiemelése.
    rowRender(h: any, trElement: any, defaultSlots: any, props: any) {
      const selected = this.isEditing(props.dataItem);
      return h(
        trElement.tag,
        {
          ...trElement.data,
          class: [trElement.data && trElement.data.class, selected ? "selected-row" : ""],
        },
        trElement.children
      );
    },

    // Kuka: a soron belüli sárga törlés-megerősítő nyitása/zárása (lista minta; egyszerre csak egy nyitva,
    // újbóli kattintásra bezár). A Kendo magától teljes szélességre húzza a detail-cellát — nincs colspan hack.
    askDelete(item: BookingTemplateItem) {
      if (!this.editor) return;
      const reopen = !!item.deleting;
      this.editor.items.forEach((x) => (x.deleting = false));
      if (reopen) return;
      item.deleting = true;
    },

    confirmRemove(item: BookingTemplateItem) {
      item.deleting = false;
      this.removeItem(item);
    },

    cancelRemove(item: BookingTemplateItem) {
      item.deleting = false;
    },

    // A LookupComboBox a kiválasztott sor teljes objektumát adja (@change payload = számla-sor).
    onAccountChange(item: BookingTemplateItem, selected: any) {
      if (!selected || !selected.id) {
        item.accno = 0;
        item.accnoCode = null;
        item.accnoName = null;
        return;
      }
      item.accno = selected.id;
      item.accnoCode = selected.accno;
      item.accnoName = selected.nationalLong;
    },

    // Dimenzió-kódok (mmbokdimcode) az adott típushoz: type 2 = dim1, 3 = dim2, 4 = dim3.
    dimCodesFor(type: number): any[] {
      return this.dimensions.filter((d) => d.type === type);
    },

    // A LookupComboBox a kiválasztott dimenzió-sort adja; 1 = nincs dimenzió (K2D dimcode sentinel).
    onDimCodeChange(item: BookingTemplateItem, dimNo: number, selected: any) {
      const id = selected && selected.id ? selected.id : 1;
      const display = selected && selected.id ? selected.dimcode : null;
      if (dimNo === 1) {
        item.dimcode1 = id;
        item.dimcode1Display = display;
      } else if (dimNo === 2) {
        item.dimcode2 = id;
        item.dimcode2Display = display;
      } else {
        item.dimcode3 = id;
        item.dimcode3Display = display;
      }
    },

    // Napló-váltás után a megjelenített nevet (bookTypeDisplay) is frissítjük.
    onBookTypeChange(item: BookingTemplateItem) {
      const bt = this.bookTypes.find((b) => b.id === item.bookType);
      item.bookTypeDisplay = bt ? bt.name : null;
    },

    hasDimensions(item: BookingTemplateItem): boolean {
      return (
        (item.dimensions && item.dimensions.length > 0) ||
        item.dimcode1 > 1 ||
        item.dimcode2 > 1 ||
        item.dimcode3 > 1
      );
    },

    dimensionSummary(item: BookingTemplateItem): string {
      const parts: string[] = [];
      if (item.dimcode1 > 1) parts.push(`1. dim: ${item.dimcode1Display || item.dimcode1}`);
      if (item.dimcode2 > 1) parts.push(`2. dim: ${item.dimcode2Display || item.dimcode2}`);
      if (item.dimcode3 > 1) parts.push(`3. dim: ${item.dimcode3Display || item.dimcode3}`);
      if (item.dimensions && item.dimensions.length) {
        parts.push(t("GeneralLedger_Db49DimFelosztas", [item.dimensions.length]));
      }
      return parts.join(", ") || t("GeneralLedger_NincsDimenzio");
    },

    async save() {
      if (this.error) {
        eventBus.$emit("error", this.error);
        return;
      }
      this.saving = true;
      eventBus.$emit("busy-message", true);
      try {
        const result = await api.SaveBookingTemplate(this.editor as BookingTemplate);
        if (!result.success) {
          eventBus.$emit("error", result.message);
          return;
        }
        eventBus.$emit("success", result.message);
        // Mentés után az oldalon maradunk (nincs visszanavigálás a listára). Új sablonnál átváltunk
        // a kapott id szerkesztő útvonalára, hogy a következő mentés már módosítás legyen; az
        // újratöltés a mentett állapotot (a mentéskor újragenerált tétel-ID-kkal) hozza vissza.
        if (!this.isEdit && result.id > 1) {
          await this.$router.replace(`/booking-templates/edit/${result.id}`);
        }
        await this.loadEditor();
      } finally {
        this.saving = false;
        eventBus.$emit("busy-message", false);
      }
    },

    // A szerkesztő (újra)betöltése: szerkesztésnél a mentett sablon állapota, új sablonnál üres űrlap.
    async loadEditor() {
      const id = Number(this.$route.params.id) || 0;
      if (id > 1) {
        const tpl = await api.GetBookingTemplate(id);
        // Stabil UI-kulcs a Kendo grid soraihoz (lásd removeItem / :data-item-key), és a 'deleting'
        // flag kezdőértéke — hogy REAKTÍV legyen (Vue 2: az observe után felvett prop nem reaktív),
        // különben az askDelete nem nyitja ki a sárga törlés-megerősítő detail-sort.
        tpl.items.forEach((it) => {
          it.uid = ++this.uidCounter;
          it.deleting = false;
          // A felosztás-sorok törlés-megerősítője is detail-sorral megy (BookingTemplateItemDimensionEdit).
          it.dimensions.forEach((d) => (d.deleting = false));
        });
        this.editor = tpl;
      } else {
        this.editor = emptyBookingTemplate();
        // Új sablon: a fej létrehozóját a bejelentkezett felhasználóval, a létrehozás dátumát a
        // mai nappal töltjük ki — a backend a mentéskor ugyanezt perzisztálja (UserId = _currentUser).
        // Az insDate üres stringje egyébként a mentésnél deszerializációs hibát (null DTO -> "Hiányzó
        // adat.") okozna, mert a DTO InsDate mezője nem nullable DateTime.
        this.editor.insDate = new Date().toISOString();
        this.editor.createdBy = auth.userName;
      }
      // Betöltéskor oldalanként az első tétel kerül kijelölésre, így a dimenzió-listák azonnal
      // a megfelelő oldal tételének felosztásait mutatják (TransactionEditor minta).
      this.selectedDebitItem = this.sideItems("+")[0] || null;
      this.selectedCreditItem = this.sideItems("-")[0] || null;
    },

    // Mégse: a nem mentett fej- és tétel-módosítások eldobása és visszanavigálás a böngésző
    // előzményében az előző oldalra (tipikusan a sablon-listára).
    async cancel() {
      this.$router.back();
    },
  },
});
